// @flow

import { Component } from '../../jsti/core';
import Template from '../../classes/Template';
import Notifications from '../../constants/Notifications';
import type { CarouselImage } from '../../interfaces/Image';
import PictureMedia from '../../classes/PictureMedia';
import ImageTypes from '../../constants/CarouselSlider/ImageTypes';

export default class CarouselSliderItemWrapper extends Component {
  #template: HTMLLIElement;
  index: number = 0;

  /**
   * Instantiate the component
   */
  bind(pEl: HTMLElement) {
    super.bind(pEl);
    this.#template = Template.getContent(this.el.getElementByRef('carousel-slider-item-template'));

    this.addListener(Notifications.CHANGE_PRODUCT, this.handleUpdate.bind(this));
  }

  /**
   * Executes when a change notification is received
   */
  handleUpdate({ product: { id } }: { product: { id: number }}): void {
    throw new Error('Abstract method');
  }

  /**
   * Rebuild the component with new media
   */
  rebuildComponent(productId: number): void {
    this.variants.forEach((element: HTMLLIElement) => element.remove());

    window.store.carouselMedia
      .filter((image: CarouselImage) => image.productId === productId)
      .reverse()
      .forEach((image: CarouselImage) => {
        if (this.items.length && this.items[0].nextSibling) {
          this.el.insertBefore(this.buildItem(image), this.items[0].nextSibling);
        } else {
          this.el.appendChild(this.buildItem(image));
        }
      });
  }

  /**
   * Build the item and return it
   */
  buildItem({ src, alt }: CarouselImage): HTMLLIElement {
    const item = this.#template.cloneNode(true);
    const picture = item.querySelector('picture');
    picture.innerHTML = new PictureMedia(picture, { src, alt }).build().innerHTML;
    return item;
  }

  /**
   * Get the carousel slider items
   */
  get items(): Array<HTMLLIElement> {
    return [...this.el.children].filter((child: HTMLElement) => child instanceof HTMLLIElement);
  }

  /**
   * Get all carousel slider variants
   *
   */
  get variants(): Array<HTMLLIElement> {
    return this.items.filter((element: HTMLLIElement) => element.dataset.type === ImageTypes.VARIANT);
  }
}
